import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './MarketEquity.css';
import { useNavigate } from "react-router-dom";
import URLstateContext from "../../provider/CommonContext";
import Market from "../Market/Market"

function MarketEquity(props) {
    let getOption = props.optionInfoMarket;
    let getOptionNews = props.optionNews;
    let getOptionNewsType = props.optionNewsType;
    const { BaseURL } = useContext(URLstateContext);
    const [optionType, setOptionType] = useState('Daily Market Tracker');
    const [optionInfoD, setOptionInfoD] = useState('');
    const [optionInfoC, setOptionInfoC] = useState('');
    const [optionInfoN, setOptionInfoN] = useState('');
    const [optionInfoA, setOptionInfoA] = useState('');
    const [optionInfoOI, setOptionInfoOI] = useState('');
    let navigate = useNavigate();

    useEffect(() => {
        if (optionType === "Company Profile") {
            navigate("/CompanyProfile/Get-Quotes");
        }
        if (optionType === "Daily Market Tracker" && optionInfoD === "Gainers & Losers") {
            navigate("/MarketEquity/Gainers-and-Losers");
        }
        if (optionInfoD === "Exchange Holidays") {
            navigate("/MarketEquity/Exchange-Holidays");
        }
        if (optionInfoD === "Historical Returns") {
            navigate("/MarketEquity/Historical-Returns");
        }
        if (optionInfoD === "Only Buyers / Sellers") {
            navigate("/MarketEquity/Only-Buyers-Sellers");
        }
        if (optionInfoD === "Beta - Stock wise") {
            navigate("/MarketEquity/Beta-Stock-wise");
        }
        if (optionInfoD === "Deliverable Volumes") {
            navigate("/MarketEquity/Deliverable-Volumes");
        }
        if (optionInfoD === "Block Deals") {
            navigate("/MarketEquity/Block-Deals");
        }
        if (optionInfoD === "Bulk Deals") {
            navigate("/MarketEquity/Bulk-Deals");
        }
        if (optionInfoD === "Live Indices") {
            navigate("/MarketEquity/Live-Indices");
        }
        if (optionInfoD === "Out / Under Performers") {
            navigate("/MarketEquity/Out-Under-Performers");
        }
        if (optionInfoD === "Unusual Volume") {
            navigate("/MarketEquity/Unusual-Volume");
        }
        if (optionInfoD === "Value / Volume Toppers") {
            navigate("/MarketEquity/Value-Volume-Toppers");
        }
        if (optionInfoD === "52 Week High/Low") {
            navigate("/MarketEquity/52-Week-High-Low");
        }
        if (optionInfoD === "Advance and Decline") {
            navigate("/MarketEquity/Advance-and-Decline");
        }
        if (optionInfoD === "New High & Low") {
            navigate("/MarketEquity/New-High-Low");
        }
        if (optionInfoD === "Index Constituents") {
            navigate("/MarketEquity/Index-Constituents");
        }
        if (optionInfoD === "Rising VDP") {
            navigate("/MarketEquity/Rising-VDP");
        }
        if (optionInfoD === "Rising Volume, Delivery & Fall In Price") {
            navigate("/MarketEquity/Rising-Volume-Delivery-Fall-In-Price");
        }
        if (optionInfoD === "Chart - Intraday Sensex") {
            navigate("/MarketEquity/Chart-Intraday-Sensex");
        }
        if (optionInfoD === "5 Days Up / Down") {
            navigate("/MarketEquity/5-Days-Up-Down");
        }
        if (optionInfoD === "Overview") {
            navigate("/market/stocks");
        }
        if (optionInfoC === "Get Quotes") {
            navigate("/CompanyProfile/Get-Quotes");
        }
        if (optionInfoN === "Corporate News") {
            navigate("/CompanyNews/Corporate-News");
        }
        if (optionInfoN === "Economy News") {
            navigate("/CompanyNews/Economy-News");
        }
        if (optionInfoN === "End-Session Commentary") {
            navigate("/CompanyNews/End-Session-Commentary");
        }
        if (optionInfoN === "Foreign Markets") {
            navigate("/CompanyNews/Foreign-Markets");
        }
        if (optionInfoN === "Hot Pursuit") {
            navigate("/CompanyNews/Hot-Pursuit");
        }
        if (optionInfoN === "Market Beat") {
            navigate("/CompanyNews/Market-Beat");
        }
        if (optionInfoN === "Mid-Session Commentary") {
            navigate("/CompanyNews/Mid-Session-Commentary");
        }
        if (optionInfoN === "Other Markets News") {
            navigate("/CompanyNews/Other-Markets-News");
        }
        if (optionInfoN === "Pre-Session Commentary") {
            navigate("/CompanyNews/Pre-Session-Commentary");
        }
        if (optionInfoN === "Stock Alert") {
            navigate("/CompanyNews/Stock-Alert");
        }
        if (optionInfoN === "Futures Market") {
            navigate("/CompanyNews/Futures-Market");
        }
        if (optionInfoN === "Corporate Results") {
            navigate("/CompanyNews/Corporate-Results");
        }
        if (optionInfoOI === "FII Investment") {
            navigate("/OtherMarket/FII-Investment");
        }
        if (optionInfoOI === "MF Investment") {
            navigate("/OtherMarket/MF-Investment");
        }
        if (optionInfoOI === "World Indices") {
            navigate("/OtherMarket/World-Indices");
        }
        if (optionInfoOI === "ADR Prices") {
            navigate("/OtherMarket/ADR-Prices");
        }
        if (optionInfoOI === "Forex") {
            navigate("/OtherMarket/Forex");
        }
        if (optionInfoA === "Daily Announcements") {
            navigate("/CorporateAction/Daily-Announcements");
        }
        if (optionInfoA === "Board Meetings") {
            navigate("/CorporateAction/Board-Meetings");
        }
        if (optionInfoA === "Book Closure") {
            navigate("/CorporateAction/Book-Closure");
        }
        if (optionInfoA === "Bonus") {
            navigate("/CorporateAction/Bonus");
        }
        if (optionInfoA === "BuyBack List") {
            navigate("/CorporateAction/BuyBack-List");
        }
        if (optionInfoA === "Rights") {
            navigate("/CorporateAction/Rights");
        }
        if (optionInfoA === "De-listed shares") {
            navigate("/CorporateAction/De-listed-Shares");
        }
        if (optionInfoA === "Market Turnover") {
            navigate("/CorporateAction/Market-Turnover");
        }
        if (optionInfoA === "Change of Name") {
            navigate("/CorporateAction/Change-Name");
        }
        if (optionInfoA === "Split of Face Value") {
            navigate("/CorporateAction/Split-Face-Value");
        }
        if (optionInfoA === "Dividend") {
            navigate("/CorporateAction/Dividend");
        }
    }, [optionInfoD,optionInfoN,optionInfoC,optionType,optionInfoOI,optionInfoA]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    {/* aria-label="Daily Market Tracker" updated */}
                                    <select aria-label="Daily Market Tracker" onChange={(event) => { setOptionType(event.target.value) }}>
                                        <option value="Daily Market Tracker">Daily Market Tracker</option>
                                        <option value="Company Profile">Company Profile</option>
                                        <option value="CM Live News">CM Live News</option>
                                        <option value="Corporate Announcements">Corporate Announcements</option>
                                        <option value="Other Market Info">Other Market Info</option>
                                    </select>
                                </div>
                                <div className='market-select'>
                                    {/* aria-label="Overview" updated */}
                                    {(optionType === "Daily Market Tracker") ?
                                    
                                        <select aria-label="Overview" value={getOption} onChange={(event) => { setOptionInfoD(event.target.value) }}>
                                            <option value={"Overview"}>Overview</option>
                                            <option value={"Chart - Intraday Sensex"}>Chart - Intraday Sensex/Nifty</option>
                                            <option value={"Gainers & Losers"} selected={optionInfoD === "Gainers & Losers"}>Gainers & Losers</option>
                                            <option value={"52 Week High/Low"}>52 Week High/Low</option>
                                            <option value={"Advance and Decline"}>Advances and Declines</option>
                                            <option value={"New High & Low"}>New High & Low</option>
                                            <option value={"Value / Volume Toppers"}>Value / Volume Toppers </option>
                                            <option value={"Out / Under Performers"}>Out / Under Performers</option>
                                            <option value={"Only Buyers / Sellers"}>Only Buyers / Sellers </option>
                                            <option value={"Unusual Volume"}>Unusual Volume</option>
                                            <option value={"Beta - Stock wise"}>Beta - Stock wise</option>
                                            <option value={"Exchange Holidays"}>Exchange Holidays </option>
                                            <option value={"Deliverable Volumes"}>Deliverable Volumes</option>
                                            <option value={"Bulk Deals"}>Bulk Deals</option>
                                            <option value={"Block Deals"}>Block Deals</option>
                                            <option value={"Index Constituents"}>Index Constituents</option>
                                            <option value={"Historical Returns"}>Historical Returns</option>
                                            <option value={"Live Indices"}>Live Indices </option>
                                            <option value={"Rising VDP"}>Rising VDP</option>
                                            <option value={"Rising Volume, Delivery & Fall In Price"}>Rising Volume, Delivery & Fall In Price</option>
                                            <option value={"5 Days Up / Down"}>5 Days Up/Down</option>
                                        </select> : ''}
                                    {(optionType === "Company Profile") ?
                                        <select onChange={(event) => { setOptionInfoC(event.target.value) }}>
                                            <option value={"Get Quotes"}>Get Quotes</option>
                                            <option value={"Company Background"}>Company Background</option>
                                            <option value={"Board of Directors"}>Board of Directors</option>
                                            <option value={"Balance Sheet"}>Balance Sheet</option>
                                            <option value={"Profit & Loss Accounts"}>Profit & Loss Accounts</option>
                                            <option value={"Quarterly Results"}>Quarterly Results</option>
                                            <option value={"Key Financial Ratios"}>Key Financial Ratios</option>
                                            <option value={"Share Price"}>Share Price</option>
                                            <option value={"Intraday / EOD charts"}>Intraday / EOD charts</option>
                                            <option value={"Cash Flow"}>Cash Flow</option>
                                            <option value={"Company Snapshot"}>Company Snapshot</option>
                                            <option value={"Share Holding Pattern"}>Share Holding Pattern</option>
                                            <option value={"Directors Reports"}>Directors Reports</option>
                                            <option value={"MF Holdings"}>MF Holdings</option>
                                            <option value={"Name Change"}>Name Change</option>
                                            <option value={"Company News"}>Company News</option>
                                            <option value={"Peer Comparison"}>Peer Comparison</option>
                                            <option value={"Bonus History"}>Bonus History</option>
                                            <option value={"Dividend"}>Dividend</option>
                                            <option value={"Rights"}>Rights</option>
                                            <option value={"Prev Quarter Comp"}>Prev Quarter Comp</option>
                                            <option value={"Announcements"}>Announcements</option>
                                            <option value={"Board Meeting"}>Board Meeting</option>
                                            <option value={"Book Closure"}>Book Closure</option>
                                        </select> : ''}
                                    {(optionType === "CM Live News") ?
                                        <select id="news" onChange={(event) => { setOptionInfoN(event.target.value) }}>
                                            <option>Select</option>
                                            <option value={"Hot Pursuit"}>Hot Pursuit</option>
                                            <option value={"Pre-Session Commentary"}>Pre-Session Commentary</option>
                                            <option value={"Mid-Session Commentary"}>Mid-Session Commentary</option>
                                            <option value={"End-Session Commentary"}>End-Session Commentary</option>
                                            <option value={"Corporate News"}>Corporate News</option>
                                            <option value={"Market Beat"}>Market Beat</option>
                                            <option value={"Economy News"}>Economy News</option>
                                            <option value={"Other Markets News"}>Other Markets News</option>
                                            <option value={"Corporate Results"}>Corporate Results</option>
                                            <option value={"Stock Alert"}>Stock Alert</option>
                                            <option value={"Futures Market"}>Futures Market</option>
                                            {/* <option value={"Quick Peek / Review"}>Quick Peek / Review</option> */}
                                            <option value={"Foreign Markets"}>Foreign Markets</option>
                                        </select> : ''}
                                    {(optionType === "Corporate Announcements") ?
                                        <select id="corpAnn" onChange={(event) => { setOptionInfoA(event.target.value) }}>
                                            <option>Select</option>
                                            <option value={"Daily Announcements"}>Daily Announcements</option>
                                            <option value={"Board Meetings"}>Board Meetings</option>
                                            <option value={"Book Closure"}>Book Closure</option>
                                            <option value={"Bonus"}>Bonus</option>
                                            <option value={"BuyBack List"}>BuyBack List</option>
                                            <option value={"Dividend"}>Dividend</option>
                                            <option value={"Rights"}>Rights</option>
                                            <option value={"De-listed shares"}>De-listed shares</option>
                                            <option value={"Market Turnover"}>Market Turnover</option>
                                            <option value={"Change of Name"}>Change of Name</option>
                                            <option value={"Split of Face Value"}>Split of Face Value</option>
                                        </select> : ''}
                                    {(optionType === "Other Market Info") ?
                                        <select id="otherMarketInfo" onChange={(event) => { setOptionInfoOI(event.target.value) }}>
                                            <option>Select</option>
                                            <option value={"FII Investment"}>FII Investment</option>
                                            <option value={"MF Investment"}>MF Investment</option>
                                            <option value={"World Indices"}>World Indices</option>
                                            <option value={"ADR Prices"}>ADR Prices</option>
                                            <option value={"Forex"}>Forex</option>
                                        </select> : ''}
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketEquity;